var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"background-listing",attrs:{"span":24}},[_c('video',{staticClass:"video-style",attrs:{"controls":"","src":"https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/unifi-video/unifi-property.mp4","type":"video/mp4"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d05ab2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/buyOffPlanSection.vue
// module id = null
// module chunks = 